import * as React from "react";
import {SFTPSyncConfiguration} from "../../../../../generated/api";
import {Card, CardGroup, Label, Segment} from "semantic-ui-react";
import {workingConfig} from "../../configChange/ConfigSignal";
import {useEffect} from "react";


export interface SftpSyncConfigSelectorProps {
    onConfigSelected?: (configWithPath: SyncConfigWithPath) => void;
}

export function SftpSyncConfigSelector(props: React.PropsWithChildren<SftpSyncConfigSelectorProps>) {

    const [sftpSyncConfigsWithPath, setSftpSyncConfigsWithPath] = React.useState<SyncConfigWithPath[]>([]);
    const [activeSyncConfigPath, setActiveSyncConfigPath] = React.useState<string | null>(null);

    useEffect(() => {
        getConfigs();
    }, []);

    useEffect(() => {
        let selectedConfig = sftpSyncConfigsWithPath.find(config => {
            return config.path === activeSyncConfigPath;
        });

        props.onConfigSelected?.(selectedConfig);
    }, [activeSyncConfigPath]);

    function getConfigs() {
        let fileSystemWorkerConfig = JSON.parse(workingConfig.value)?.fileSystemWorkerConfiguration;
        let configsWithPath = []

        if (fileSystemWorkerConfig) {
            if (fileSystemWorkerConfig.sftpSync) {
                let path = "$.fileSystemWorkerConfiguration.sftpSync";
                let configWithPath = {
                    config: fileSystemWorkerConfig.sftpSync,
                    path: path
                } as SyncConfigWithPath;
                configsWithPath.push(configWithPath);

            }
            if (fileSystemWorkerConfig.sftpSyncList) {
                fileSystemWorkerConfig.sftpSyncList.forEach((sftpSync: SFTPSyncConfiguration, index: number) => {
                    let path = `$.fileSystemWorkerConfiguration.sftpSyncList[${index}]`;

                    let configWithPath = {
                        config: sftpSync,
                        path: path
                    } as SyncConfigWithPath;
                    configsWithPath.push(configWithPath);


                })
            }
            setSftpSyncConfigsWithPath(configsWithPath);
            if(configsWithPath.length > 0) {
                setActiveSyncConfigPath(configsWithPath[0].path);
            }
        }
    }

    function displaySingleSftpSync(configWithPath: SyncConfigWithPath) {
        let sftpSync: SFTPSyncConfiguration = configWithPath.config;
        let active = activeSyncConfigPath == configWithPath.path;
        return <Card
            color={active ? "blue" : undefined}
            style={active ? { background: "#e6f0ff", border: "2px solid #2185d0", boxShadow: "0 0 10px #2185d0" } : {}}
            raised={active}

            onClick={() => {
                setActiveSyncConfigPath(configWithPath.path);
            }}
        >
            <Card.Content>
                <Card.Header>{sftpSync.configName}</Card.Header>
                <Card.Meta>{sftpSync.remoteMachine}:{sftpSync.remotePort}</Card.Meta>
                <Card.Meta>{sftpSync.remoteSourceDir}</Card.Meta>

            </Card.Content>
        </Card>
    }

    if (sftpSyncConfigsWithPath.length == 0) {
        return <Label>No SFTP Sync Config found</Label>
    }

    return <Segment style={{width: "100%"}}>
        <CardGroup>
            {sftpSyncConfigsWithPath.map(displaySingleSftpSync)}
        </CardGroup>
    </Segment>
}


export interface SyncConfigWithPath {
    config: SFTPSyncConfiguration;
    path: string;

}